import { Box, Skeleton, Stack, Typography } from "@mui/material";

export default function LoadingAppScreen() {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Stack spacing={3}>
        {[1, 2, 3, 4].map((i) => (
          <Box
            key={i}
            sx={{
              p: 2,
              borderRadius: 2,
              backgroundColor: "background.paper",
            }}
          >
            {/* Date header */}
            <Skeleton width={200} height={30} />

            {/* Vormittag */}
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="overline"
                sx={{
                  letterSpacing: 1.2,
                  fontWeight: "bold",
                  fontSize: "0.85rem",
                }}
              >
                Vormittag
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  mt: 1,
                  flexWrap: "wrap",
                }}
              >
                {Array.from({ length: 9 }).map((_, idx) => (
                  <Skeleton
                    key={idx}
                    variant="rounded"
                    width={140}
                    height={64}
                  />
                ))}
              </Box>
            </Box>

            {/* Nachmittag */}
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="overline"
                sx={{
                  letterSpacing: 1.2,
                  fontWeight: "bold",
                  fontSize: "0.85rem",
                }}
              >
                Nachmittag
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  mt: 1,
                  flexWrap: "wrap",
                }}
              >
                {Array.from({ length: 9 }).map((_, idx) => (
                  <Skeleton
                    key={idx}
                    variant="rounded"
                    width={140}
                    height={64}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
